document.addEventListener('DOMContentLoaded',()=>{let wishlist=JSON.parse(localStorage.getItem('wishlist'))||[];document.querySelectorAll('.m-wishlist-tooltip').forEach((button)=>{const handle=button.getAttribute('data-product-handle');const contentSpan=button.querySelector('.m-wishlist-tooltip__content');const atcText=contentSpan.getAttribute('data-atc-text');const revertText=contentSpan.getAttribute('data-revert-text');if(wishlist.includes(handle)){button.classList.add('wishlist-active');contentSpan.textContent=revertText;}else{button.classList.remove('wishlist-active');contentSpan.textContent=atcText;}});updateWishlistCount();checkWishlistEmpty();});function isInWishlist(handle){const wishlist=JSON.parse(localStorage.getItem('wishlist'))||[];return wishlist.includes(handle);}
function checkWishlistEmpty(button=null){const wishlist=JSON.parse(localStorage.getItem('wishlist'))||[];const container=document.querySelector('.wishlist__content');if(!container)return;if(button){const productItem=button.closest('.wishlist-product.grid__item');if(productItem)productItem.remove();}
if(!window.location.pathname.includes('/pages/wishlist'))return;if(wishlist.length===0){container.innerHTML=`

      <h1 style="text-align:center;min-height:400px;display:flex;justify-content:center;align-items:center;flex-direction:column;">

        No products were added to the wishlist page.

        <a class="m-text-link" style="color:black;" href="/collections/all"> Back to shopping </a>

      </h1>

    `;}}
function addToWishlist(button){const handle=button.getAttribute('data-product-handle');let wishlist=JSON.parse(localStorage.getItem('wishlist'))||[];const contentSpan=button.querySelector('.m-wishlist-tooltip__content');const atcText=contentSpan.getAttribute('data-atc-text');const revertText=contentSpan.getAttribute('data-revert-text');if(!isInWishlist(handle)){wishlist.push(handle);button.classList.add('wishlist-active');contentSpan.textContent=revertText;}else{wishlist=wishlist.filter(item=>item!==handle);button.classList.remove('wishlist-active');contentSpan.textContent=atcText;}
localStorage.setItem('wishlist',JSON.stringify([...new Set(wishlist)]));const form=button.closest('span')?.querySelector('form');if(form){const input=form.querySelector('input[name="attributes[wishlist]"]');if(input){input.value=wishlist.join(',');fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{wishlist:wishlist.join(',')}}),}).then(res=>res.json()).then(data=>console.log('Cart updated:',data.attributes)).catch(err=>console.error('Cart update error:',err));}}
updateWishlistCount();checkWishlistEmpty(button);}
function updateWishlistCount(){const wishlist=JSON.parse(localStorage.getItem('wishlist'))||[];const counter=document.querySelector('[data-val-count]');if(counter){counter.textContent=wishlist.length;}}

function removeFromWishlist(button) {
  const handle = button.getAttribute('data-product-handle');
  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  // Remove item from array
  wishlist = wishlist.filter(item => item !== handle);

  // Save updated wishlist
  localStorage.setItem('wishlist', JSON.stringify(wishlist));

  // Remove product card from wishlist page
  const productItem = button.closest('.wishlist-product.grid__item');
  if (productItem) {
    productItem.remove();
  }

  // Update all wishlist buttons (icons/tooltips)
  document.querySelectorAll(`.m-wishlist-tooltip[data-product-handle="${handle}"]`)
    .forEach(btn => {
      const contentSpan = btn.querySelector('.m-wishlist-tooltip__content');
      if (!contentSpan) return;

      btn.classList.remove('wishlist-active');
      contentSpan.textContent = contentSpan.getAttribute('data-atc-text');
    });

  // Update cart attribute if needed
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: { wishlist: wishlist.join(',') }
    })
  }).catch(err => console.error('Cart update error:', err));

  updateWishlistCount();
  checkWishlistEmpty();
}
